import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import CheckInput from '@components/LocalMerchant/SetMealCreate/CheckInput'
import 'antd4/lib/grid/style/index.css'
import { MagicInput, Radio } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Store from './store'
import { isString } from '@util'

const Item = Form.Item
const RadioGroup = Radio.Group
@Form.create()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }
  componentDidMount() {
    const { value } = this.props.data
    this.store.init(value)
  }
  render() {
    const index = this.props.index
    const {
      text,
      options = [],
      key,
      // placeholder,
      value,
      required
    } = this.props.data

    const { getFieldDecorator, setFieldsValue } = this.props.form
    const { showExtend } = this.store

    const customize = this.props.sourceService?.childNodes
      ?.find(f => f.key === key)
      .options?.find(f => f.type)

    const { fontLimit = 10, placeholder, type } = customize || {}

    let initialValue = ''
    if (value) {
      if (value.id) {
        initialValue = value.id + ''
      } else if (value.title) {
        initialValue = '-1'
      } else if (isString(value)) {
        initialValue = value + ''
      }
    }

    return (
      <>
        <Item label={text} key={index}>
          {getFieldDecorator(`${key}-id`, {
            initialValue: initialValue,
            rules: [{ required, message: `${text}信息未填写` }]
          })(
            <RadioGroup
              onChange={e => {
                this.store.showExtend = e.target.value === '-1'
                if (e.target.value !== '-1') {
                  setFieldsValue({ [`${key}-title`]: '' })
                }
              }}
            >
              {options.map(({ title, id }, index) => {
                id =
                  id === '-1' ||
                  id === '自定义' ||
                  title === '自定义' ||
                  title === '其他' ||
                  title === '其他证书'
                    ? '-1'
                    : id
                return (
                  <Radio key={id} value={id + ''}>
                    {title}
                  </Radio>
                )
              })}
            </RadioGroup>
          )}
        </Item>
        {showExtend && (
          <Item>
            {getFieldDecorator(`${key}-title`, {
              initialValue: value ? value.title : '',
              rules: [{ required, message: `${text}信息未填写` }]
            })(
              <CheckInput
                inputChange={value => {
                  setFieldsValue({ [`${key}-title`]: value })
                }}
              >
                {type === 'textArea' ? (
                  <MagicInput.TextArea
                    maxLength={fontLimit}
                    showCount
                    countPosition="inner"
                    placeholder={placeholder}
                  />
                ) : (
                  <MagicInput
                    style={{
                      marginTop: 10,
                      marginRight: 10
                    }}
                    maxLength={fontLimit}
                    showCount
                    countPosition="inner"
                    placeholder={placeholder}
                  />
                )}
              </CheckInput>
            )}
          </Item>
        )}
      </>
    )
  }
}
